export default function getPayload(data, newValue) {
  return ({
    ...data,
    orderStatus: newValue,
    quote: data.quote.id,
  });
}
